import React, { useContext, useEffect, useRef, useState } from "react";
import GloblePopup from "../common/GloblePopup";
import { GlobalContext } from "../global/GlobalProvider";
import config from "../config";
import { useTranslation } from "react-i18next";

export default function StackUpdateFixedBox({ isStackOpen, handleClose }) {
  const { t, i18n } = useTranslation();
  const {
    setAlertMsg,
    openSuccessPopup,
    openErrorPopup,
    setStackList,
  } = useContext(GlobalContext);

  const token = sessionStorage.getItem("token");
  const initialized = useRef(false);

  const [stackList, setStackLists] = useState([]);
  const [inputs, setInputs] = useState([]);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getStackListAPI();
    }
  }, []);

  const getStackListAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      whiteLabelName: config.WhiteLable,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/getStakeLabes2`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        const data = Array.isArray(paresData.data) ? paresData.data : [];

        // Fill to exactly 8 items
        const paddedData = [...data];
        while (paddedData.length < 8) {
          paddedData.push({ key: "", value: "" });
        }

        setStackLists(paddedData);
        setInputs(paddedData);
        sessionStorage.setItem("stackList", JSON.stringify(paddedData));
        setStackList(JSON.stringify(paddedData));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setStackListAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      data: inputs,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/updateStake2`, requestOptions)
      .then(async (response) => {
        if (response.ok) {
          let paresData = await response.json();
          sessionStorage.setItem("stackList", JSON.stringify(paresData.data));
          setStackList(JSON.stringify(paresData.data));
          openSuccessPopup();
          setAlertMsg("Stack Update Successfully!");
          handleClose();
        } else {
          openErrorPopup();
          setAlertMsg("Something went wrong!");
          handleClose();
        }
      })
      .catch((error) => {
        console.log(error);
        handleClose();
      });
  };

  const handleInputChange = (index, field, newValue) => {
    const updatedInputs = [...inputs];
    updatedInputs[index] = {
      ...updatedInputs[index],
      [field]: newValue,
    };
    setInputs(updatedInputs);
  };

  return (
    <GloblePopup
      isOpen={isStackOpen}
      onClose={handleClose}
      title={t("Set Button Value")}
      className="stack-btn-popup"
      cancelText="Close"
    >
      <div className="table-responsive">
        <table className="table button-value">
          <thead>
            <tr>
              <th>{t('Price Label')}</th>
              <th>{t('Price Value')}</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, index) => {
              const value = stackList[index] || {};
              return (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      value={inputs[index]?.key ?? value.key ?? ""}
                      onChange={(e) =>
                        handleInputChange(index, "key", e.target.value)
                      }
                      placeholder="Key"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={inputs[index]?.value ?? value.value ?? ""}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "value",
                          Number(e.target.value)
                        )
                      }
                      className="form-control"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="text-right">
        <button
          className="btn btn-primary btn-block w-100"
          onClick={setStackListAPI}
        >
          {t('Submit')}
        </button>
      </div>
    </GloblePopup>
  );
}
